export default __webpack_public_path__ + "static/media/MLeaf.a047f14f.jpg";